var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.379 12.4933C182.379 10.1938 180.517 8.33151 178.217 8.33151H152.039C149.739 8.33151 147.877 6.46534 147.877 4.16582C147.877 1.86629 149.739 0.000130892 152.039 0.000130892H178.217C185.116 0.000130892 190.71 5.59473 190.71 12.4932V38.6717C190.71 40.9712 188.844 42.8335 186.545 42.8335C184.245 42.8335 182.379 40.9712 182.379 38.6717L182.379 12.4933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33091 178.217C8.33091 180.517 10.1932 182.379 12.4927 182.379L38.6712 182.379C40.9707 182.379 42.833 184.245 42.833 186.545C42.833 188.844 40.9707 190.71 38.6712 190.71L12.4927 190.71C5.59423 190.71 -0.000360645 185.116 -0.000360042 178.217L-0.000357753 152.039C-0.000357552 149.739 1.8658 147.877 4.16533 147.877C6.46485 147.877 8.33102 149.739 8.33102 152.039L8.33091 178.217Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.217 182.379C180.517 182.379 182.379 180.517 182.379 178.217L182.379 152.039C182.379 149.739 184.245 147.877 186.545 147.877C188.844 147.877 190.71 149.739 190.71 152.039L190.71 178.217C190.71 185.116 185.116 190.71 178.217 190.71L152.039 190.71C149.739 190.71 147.877 188.844 147.877 186.545C147.877 184.245 149.739 182.379 152.039 182.379L178.217 182.379Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4928 8.3314C10.1933 8.3314 8.33102 10.1937 8.33102 12.4932L8.33102 38.6717C8.33102 40.9712 6.46485 42.8335 4.16533 42.8335C1.8658 42.8335 -0.000357145 40.9712 -0.000356844 38.6717L-0.000353411 12.4932C-0.000352506 5.59472 5.59424 0.000126009 12.4927 0.000126913L38.6712 0.000130346C40.9707 0.000130648 42.833 1.86629 42.833 4.16582C42.833 6.46534 40.9707 8.3315 38.6712 8.3315L12.4928 8.3314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanframe);
export default __webpack_public_path__ + "static/media/scanframe.f040f00f295decd739822db902de1277.svg";
export { ForwardRef as ReactComponent };